import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-section-outline-block',
  templateUrl: './section-outline-block.component.html',
  styleUrls: ['./section-outline-block.component.scss'],
})
export class SectionOutlineBlockComponent {
  @Input() public className: string = '';
  @Input() public headerTitle: string;
  @Input() public theme: 'default' | 'highlighted' = 'default';
  @Input() public isShowHeaderBorder: boolean = false;
  @Input() public floatingTitle: string;
  @Input() public isShowFloatingTitle: boolean = true;
}
